/* eslint-disable no-shadow,consistent-return,no-param-reassign */

const state = {
  // Set default state(s) here
  // example: null,
  loading_state: {
    is_loading: false
  }
};

const getters = {};

const mutations = {
  // show Loading
  showLoading(state) {
    state.loading_state.is_loading = true;
  },

  // hide loading
  hideLoading(state) {
    state.loading_state.is_loading = false;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
